<app-image-gallery
  [images]="images"
  [show-info]="showInfoOptions"
  (singleSelection)="openBottomSheetActions($event)"
></app-image-gallery>
